var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        {
          staticClass: "text-left right-inner-addon mb-4",
          attrs: { cols: "12" },
        },
        [
          _c(
            "div",
            { staticClass: "right-inner-addon" },
            [
              _c("icon", { attrs: { name: "search" } }),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.trim",
                    value: _vm.search,
                    expression: "search",
                    modifiers: { trim: true },
                  },
                ],
                staticClass: "form-control search-inactive-clients",
                attrs: {
                  id: "agent-search",
                  type: "search",
                  placeholder: "" + _vm.$t("agents.searchFor"),
                  autocomplete: "off",
                },
                domProps: { value: _vm.search },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.search = $event.target.value.trim()
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "label",
                { staticClass: "d-none", attrs: { for: "agent-search" } },
                [_vm._v(_vm._s(_vm.$t("global.words.sear")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _vm.loading
            ? _c("b-card", [_c("agents-loader")], 1)
            : _c("v-client-table", {
                staticClass: "card vue-custom-table no-pagination",
                attrs: {
                  data: _vm.filteredAgents,
                  columns: _vm.columns,
                  options: _vm.options,
                },
                scopedSlots: _vm._u([
                  {
                    key: "fullName",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center" },
                          [
                            _c(
                              "profile-avatar",
                              _vm._b(
                                { staticClass: "client-avatar" },
                                "profile-avatar",
                                row,
                                false
                              )
                            ),
                            _vm._v(" "),
                            _c(
                              "router-link",
                              {
                                staticClass: "bold text-grey mx-2",
                                attrs: { to: _vm.agentDetailsLink(row) },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(row.givenName) +
                                    " " +
                                    _vm._s(row.familyName) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            row.username === _vm.CURRENT_USER_USERNAME
                              ? _c("p", { staticClass: "m-0 font-sm" }, [
                                  _vm._v(
                                    "\n            (" +
                                      _vm._s(_vm.$t("global.words.you")) +
                                      ")\n          "
                                  ),
                                ])
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "clients",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n        " + _vm._s(row.clients.length) + "\n      "
                        ),
                      ]
                    },
                  },
                  {
                    key: "lastLoggedIn",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.formatTimeAgo(row.lastLoggedIn)) +
                            "\n      "
                        ),
                      ]
                    },
                  },
                  {
                    key: "actions",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c(
                          "b-col",
                          { staticClass: "d-flex flex-column align-items-end" },
                          [
                            _c(
                              "router-link",
                              {
                                staticClass:
                                  "btn bold btn-white btn-sm d-lg-inline d-none",
                                attrs: { to: _vm.agentDetailsLink(row) },
                              },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(_vm.$t("agents.viewAgent")) +
                                    "\n          "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "dropleft d-flex d-xl-none" },
                              [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "grey-text text-darken-4 clickable d-lg-none",
                                    attrs: { "data-toggle": "dropdown" },
                                  },
                                  [
                                    _c("i", { staticClass: "material-icons" }, [
                                      _vm._v("more_vert"),
                                    ]),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "dropdown-menu" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "dropdown-item clickable wide px-4",
                                    },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          staticClass: "btn btn-white",
                                          attrs: {
                                            to: _vm.agentDetailsLink(row),
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                  " +
                                              _vm._s(
                                                _vm.$t("agents.viewAgent")
                                              ) +
                                              "\n                "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ]),
                              ]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }